export default __webpack_public_path__ + "static/media/prev-NavIC-Clock-6.febaea9b.png";